<template>
  <div class="materials-header">
    <h1>новые материалы</h1>
    <div class="materials-header__categories">
      <nuxt-link
        :class="['m-btn', getCategoryClass(), {
          'active': $route.name === 'articles',
        }]"
        to="/articles"
      >
        все статьи
      </nuxt-link>
      <button
        v-for="category in categories"
        :key="category.id"
        :class="['m-btn', getCategoryClass(category), {
          'active': category.id === currentCategory.id,
        }]"
        @click="filterClick(category)"
      >
        {{ category.name }}
      </button>
    </div>
    <div class="materials-header__search">
      <div
        :class="['materials-header__search_input', {
          'materials-header__search_input--active': more,
        }]"
      >
        <input
          v-model="searchInput"
          type="text"
          placeholder="начните вводить текст"
          @focus="more = true"
          @blur="setMoreFalse"
          @keydown.enter="search"
        >
        <img
          src="/img/materials/header/search.svg"
          alt="s"
          class="materials-header__search_img"
          @click="search"
        >

        <transition name="slide-down">
          <div
            v-if="more"
            class="materials-header__search_input--more"
          >
            <div class="materials-header__search_tags">
              <button
                v-for="(tag, index) in tags"
                :key="index"
                class="m-btn"
                @click="setTagSearch(tag)"
              >
                #{{ tag }}
              </button>
            </div>

            <div class="materials-header__search_variants">
              <nuxt-link
                v-for="material in variantsMaterials"
                :key="material.id"
                :to="`${materialCategorySlug(material)}/${material.slug || material.id}`"
              >
                <img
                  :src="`/img/materials/header/${searchInput ? 'search' : 'flash'}.svg`"
                  alt="icon"
                >
                <span class="line-clamp-1">{{ material.title }}</span>
              </nuxt-link>
            </div>
          </div>
        </transition>
      </div>

      <button
        class="m-btn materials-header__search_button"
        @click="search"
        @keydown.enter="search"
      >
        найти
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import debounce from 'lodash/debounce';
import { getCategoryClass } from './utils';

export default {
  name: 'MaterialsHeader',
  props: {
    selectedCategory: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    searchInput: '',
    variantsMaterials: [],
    more: false,
    // eslint-disable-next-line max-len,vue/max-len
    tags: ['огэ', 'егэ', 'путешествия', 'аттестация', 'экстернат', 'буллинг', 'олимпиада', 'профориентация', 'воспитание', 'льготы'],
  }),
  async fetch() {
    await this.$store.dispatch('fetchMaterialCategories');
    await this.fetchVariantsMaterial();
  },
  computed: {
    ...mapGetters({
      categories: 'getMaterialCategories',
    }),
    currentCategory: {
      get() {
        return this.selectedCategory || {};
      },
      set(value) {
        this.$emit('update:selectedCategory', value);
      },
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    searchInput: debounce(function () {
      this.fetchVariantsMaterial();
    }, 200),
  },
  beforeMount() {
    const routeTag = this.$route.query['blog-tag'];
    if (routeTag) {
      this.setTagSearch(routeTag);
      this.$router.replace({ path: this.$route.path });
    }
  },
  methods: {
    getCategoryClass,
    setMoreFalse() {
      setTimeout(() => {
        this.more = false;
      }, 200);
    },
    materialCategorySlug(material) {
      return material.categories?.[0]?.slug || 'articles';
    },
    filterClick(category) {
      if (this.currentCategory.id !== category.id) {
        this.$router.push({
          path: `/${category.slug || 'articles'}`,
          query: this.$route.query,
        });
      }
    },
    search() {
      this.$emit('search', this.searchInput);
    },
    async fetchVariantsMaterial() {
      const params = {
        orderAttributes: { views_count: 'desc' },
        perPage: this.searchInput ? 8 : 5,
      };
      if (this.searchInput) {
        const hashTag = this.searchInput[0] === '#';
        if (hashTag) {
          params.tags = [this.searchInput.replace('#', '').toLowerCase()];
        } else {
          params.title = this.searchInput;
        }
      }
      const response = await this.$api.getVariantsMaterials(params);
      this.variantsMaterials = response.publicMaterials || [];
    },
    setTagSearch(tag) {
      this.searchInput = `#${tag}`;
      this.more = false;
      this.search();
    },
  },
};
</script>

<style scoped lang="scss">

.materials-header {
  h1 {
    margin-bottom: calc(var(--scale) * 40);
    font-weight: 500;
    font-size: calc(var(--scale) * 64);
    line-height: 95%;
    letter-spacing: -0.02em;
    color: #02120F;

    @include media-down($size-tablet) {
      margin-bottom: calc(var(--scale) * 24);
      font-size: calc(var(--scale) * 44);
      line-height: 90%;
      letter-spacing: -0.06em;
    }
  }

  .materials-header__categories {
    margin-bottom: calc(var(--scale) * 20);
    display: flex;
    align-items: center;
    gap: calc(var(--scale) * 4);
    overflow: auto;
    width: calc(100% + var(--scale) * 80);
    margin-left: calc(-1 * var(--scale) * 40);
    padding-inline: calc(var(--scale) * 40);

    @include media-down($size-tablet) {
      gap: calc(var(--scale) * 2);
      width: calc(100% + var(--scale) * 32);
      margin-left: calc(-1 * var(--scale) * 16);
      padding-inline: calc(var(--scale) * 16);
    }

    @include media-down($size-mobile) {
      width: calc(100% + var(--scale) * 24);
      margin-left: calc(-1 * var(--scale) * 12);
      padding-inline: calc(var(--scale) * 12);
    }

    &::-webkit-scrollbar {
      display: none;
    }

    a,
    button {
      padding: calc(var(--scale) * 8) calc(var(--scale) * 14) calc(var(--scale) * 10);
      background-color: #5237E6;
      border-radius: calc(var(--scale) * 40);
      transition: 200ms;

      text-transform: lowercase;
      font-weight: 500;
      font-size: calc(var(--scale) * 16);
      line-height: 130%;
      color: #FFFFFF;
      white-space: nowrap;

      @include media-down($size-tablet) {
        padding: calc(var(--scale) * 6) calc(var(--scale) * 12) calc(var(--scale) * 8);
         font-size: calc(var(--scale) * 14);
      }

      &.violet {
        background-color: #E6CEFF;
        color: #5237E6;

        &.active,
        &:hover {
          background-color: #5237E6;
          color: #ffffff;
        }
      }

      &.green {
        background-color: #D1FAD8;
        color: #01410D;

        &.active,
        &:hover {
          background-color: #01410D;
          color: #ffffff;
        }
      }

      &.orange {
        background-color: #FFF0D1;
        color: #FF5319;

        &.active,
        &:hover {
          background-color: #FF5319;
          color: #ffffff;
        }
      }

      &.blue {
        background-color: #CEF9FF;
        color: #0A4183;

        &.active,
        &:hover {
          background-color: #0A4183;
          color: #ffffff;
        }
      }

      &.pink {
        background-color: #FFCEE2;
        color: #8D176C;

        &.active,
        &:hover {
          background-color: #8D176C;
          color: #ffffff;
        }
      }

      &.red {
        background-color: #FFCDCF;
        color: #8D1717;

        &.active,
        &:hover {
          background-color: #8D1717;
          color: #ffffff;
        }
      }
    }
  }

  .materials-header__search {
    display: flex;
    gap: calc(var(--scale) * 10);
    align-items: flex-start;
    position: relative;
    padding-top: 1px;

    &_input {
      width: 100%;
      position: relative;
      border-radius: calc(var(--scale) * 44);
    }

    input {
      position: relative;
      z-index: 3;
      width: 100%;
      padding-inline: calc(var(--scale) * 40) calc(var(--scale) * 66);
      height: calc(var(--scale) * 88);
      border: 1px solid #CACACB;
      border-radius: calc(var(--scale) * 44);

      font-weight: 500;
      font-size: calc(var(--scale) * 26);
      line-height: 120%;
      color: #02120F;

      @include media-down($size-tablet) {
        height: calc(var(--scale) * 68);
        padding-inline: calc(var(--scale) * 24);
        border-radius: calc(var(--scale) * 34);

        font-size: calc(var(--scale) * 18);
        line-height: 110%;
        letter-spacing: -0.02em;
      }

      &::placeholder {
        color: #A7ABAC;
      }
    }

    &_tags {
      position: relative;
      z-index: 2;
      display: flex;
      gap: calc(var(--scale) * 4);
      margin-bottom: calc(var(--scale) * 24);
      overflow-x: auto;

      @include media-down($size-tablet) {
        margin-bottom: calc(var(--scale) * 14);
        margin-left: calc(-1 * var(--scale) * 16);
        padding-top: calc(var(--scale) * 2);
        padding-inline: calc(var(--scale) * 16);
        width: calc(100% + calc(var(--scale) * 32));
      }

      &::-webkit-scrollbar {
        display: none;
      }

      button {
        padding: calc(var(--scale) * 7) calc(var(--scale) * 13) calc(var(--scale) * 9);
        border: 1px solid #CACACB;
        border-radius: calc(var(--scale) * 40);

        font-weight: 500;
        font-size: calc(var(--scale) * 16);
        line-height: 130%;
        color: #02120F;

        @include media-down($size-tablet) {
          padding: calc(var(--scale) * 5) calc(var(--scale) * 11) calc(var(--scale) * 8);
          font-size: calc(var(--scale) * 14);
        }

        &:hover {
          color: #5237E6;
        }
      }
    }

    &_variants {
      position: relative;
      z-index: 2;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: calc(var(--scale) * 24);

      @include media-down($size-tablet) {
        gap: calc(var(--scale) * 20);
      }

      a {
        display: flex;
        align-items: center;
        gap: calc(var(--scale) * 8);

        @include media-down($size-tablet) {
          gap: calc(var(--scale) * 6);
        }

        img {
          width: calc(var(--scale) * 32);
          height: calc(var(--scale) * 32);
          object-fit: contain;
          flex-shrink: 0;
          filter: invert(73%) sepia(5%) saturate(166%) hue-rotate(145deg) brightness(94%) contrast(85%);

          @include media-down($size-tablet) {
            width: calc(var(--scale) * 24);
            height: calc(var(--scale) * 24);
          }
        }

        span {
          transition: 100ms;
          font-weight: 500;
          font-size: calc(var(--scale) * 26);
          line-height: 120%;
          color: #A7ABAC;

          @include media-down($size-tablet) {
            font-size: calc(var(--scale) * 18);
          }
        }

        &:hover {
          span {
            color: #02120F;
          }

          img {
            filter: invert(43%) sepia(87%) saturate(3286%) hue-rotate(350deg) brightness(101%) contrast(101%);
          }
        }
      }
    }

    &_img {
      position: absolute;
      z-index: 3;
      right: calc(var(--scale) * 22);
      top: calc(var(--scale) * 22);
      display: block;
      padding: calc(var(--scale) * 6);
      width: calc(var(--scale) * 44);
      height: calc(var(--scale) * 44);
      filter: invert(73%) sepia(5%) saturate(166%) hue-rotate(145deg) brightness(94%) contrast(85%);

      @include media-down($size-tablet) {
        top: calc(var(--scale) * 12);
        right: calc(var(--scale) * 12);
        cursor: pointer;
        padding: calc(var(--scale) * 10);
      }
    }

    &_input--active {
      input {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-bottom: 0;
      }

      .materials-header__search_img {
        filter: invert(43%) sepia(87%) saturate(3286%) hue-rotate(350deg) brightness(101%) contrast(101%);
      }
    }

    &_input--more {
      padding-top: calc(var(--scale) * 20);
      width: 100%;
      position: absolute;
      z-index: 2;
      padding-inline: calc(var(--scale) * 40) calc(var(--scale) * 66);
      padding-bottom: calc(var(--scale) * 40);
      background-color: #FFFFFF;
      border: 1px solid #CACACB;
      border-top: 0;
      border-bottom-left-radius: calc(var(--scale) * 44);
      border-bottom-right-radius: calc(var(--scale) * 44);

      @include media-down($size-tablet) {
        padding-top: calc(var(--scale) * 8);
        padding-inline:  calc(var(--scale) * 16);
        padding-bottom: calc(var(--scale) * 20);
        border-bottom-left-radius: calc(var(--scale) * 34);
        border-bottom-right-radius: calc(var(--scale) * 34);
      }

      &:before {
        content: '';
        user-select: none;
        display: block;
        height: calc(100% + var(--scale) * 88);
        width: 100%;
        position: absolute;
        left: 0;
        top: calc(-1 * var(--scale) * 88);
        box-shadow:
          calc(var(--scale) * 10) calc(var(--scale) * 10) calc(var(--scale) * 50) rgba(7, 21, 57, 0.1),
          calc(var(--scale) * 4) calc(var(--scale) * 4) calc(var(--scale) * 20) rgba(7, 21, 57, 0.05);
        border-radius: calc(var(--scale) * 44);

        @include media-down($size-tablet) {
          top: calc(-1 * var(--scale) * 68);
          height: calc(100% + var(--scale) * 68);
          border-radius: calc(var(--scale) * 34);
        }
      }
    }

    &_button {
      flex-shrink: 0;
      width: calc(var(--scale) * 290);
      height: calc(var(--scale) * 88);
      background-color: #FF5319;
      border-radius: calc(var(--scale) * 200);
      transition: 200ms;

      font-weight: 500;
      font-size: calc(var(--scale) * 26);
      line-height: 120%;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        display: none;
      }

      @media (hover: hover) {
        &:hover {
          background-color: #FF9C12;
        }
      }
    }
  }
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: max-height 100ms ease-out, transform 100ms ease-out, opacity 100ms ease-out;
}
.slide-down-enter,
.slide-down-leave-to {
  max-height: 0;
  transform: translateY(calc(-1 * var(--scale) * 20));
  opacity: 0;
}

</style>
